module.exports = __webpack_public_path__ + "img/ring_r_i_0_null.fd537f9d.png";